export const MAX_TYPE_HISTORY = 8;

export const RECENTLY_SELECTED_MAX_HISTORY = 100;

export const HISTORY_TYPES = {
    DASHBOARD: 'dashboardHistory',
    DATA_EXPLORER: 'dataExplorerHistory',
    FEATURE: 'featureHistory',
    FEEDBACK: 'feedbackHistory',
    FUNNEL: 'funnelHistory',
    GUIDE: 'guideHistory',
    IDEA: 'ideaHistory',
    LISTEN_SAVED_VIEW: 'listenSavedViewHistory',
    NPS: 'npsHistory',
    PAGE: 'pageHistory',
    PATH: 'pathHistory',
    REPLAY_PLAYLIST: 'replayPlaylistHistory',
    RETENTION: 'retentionHistory',
    ROADMAP: 'roadmapHistory',
    SAVED_FILTER: 'savedFilterHistory',
    SURVEY: 'surveyHistory',
    SEGMENT: 'segmentHistory',
    TRACKTYPE: 'trackTypeHistory',
    WORKFLOW: 'workflowHistory',
    AI_AGENT: 'aiAgentHistory',
    ASK_PENDO: 'askPendoHistory',
};

export const RECENTLY_SELECTED_HISTORY_TYPES = {
    PAGE_RECENTLY_SELECTED: 'pageRecentlySelected',
    FEATURE_RECENTLY_SELECTED: 'featureRecentlySelected',
    TRACKTYPE_RECENTLY_SELECTED: 'trackTypeRecentlySelected',
    GUIDE_RECENTLY_SELECTED: 'guideRecentlySelected',
    AGENT_RECENTLY_SELECTED: 'agentEventRecentlySelected',
    NETWORK_REQUEST_RECENTLY_SELECTED: 'networkRequestRecentlySelected',
};

export const HISTORY_KEYS = Object.freeze({
    dashboardHistory: 'Dashboard',
    dataExplorerHistory: 'Report',
    featureHistory: 'Feature',
    feedbackHistory: 'VocItem',
    funnelHistory: 'Report',
    guideHistory: 'Guide',
    ideaHistory: 'VocItem',
    listenSavedViewHistory: 'SavedView',
    npsHistory: 'Guide',
    pageHistory: 'Page',
    pathHistory: 'Report',
    replayPlaylistHistory: 'Playlist',
    retentionHistory: 'Report',
    roadmapHistory: 'Roadmap',
    savedFilterHistory: 'SavedView',
    surveyHistory: 'Survey',
    segmentHistory: 'Segment',
    trackTypeHistory: 'TrackType',
    workflowHistory: 'Workflow',
    pageRecentlySelected: 'Page',
    featureRecentlySelected: 'Feature',
    trackTypeRecentlySelected: 'TrackType',
    guideRecentlySelected: 'Guide',
    networkRequestRecentlySelected: 'NetRequest',
    aiAgentHistory: 'Report',
    askPendoHistory: 'AskPendo',
});

export const KIND_TO_RECENT_MAP = {
    Page: RECENTLY_SELECTED_HISTORY_TYPES.PAGE_RECENTLY_SELECTED,
    Feature: RECENTLY_SELECTED_HISTORY_TYPES.FEATURE_RECENTLY_SELECTED,
    TrackType: RECENTLY_SELECTED_HISTORY_TYPES.TRACKTYPE_RECENTLY_SELECTED,
    Guide: RECENTLY_SELECTED_HISTORY_TYPES.GUIDE_RECENTLY_SELECTED,
    AIAgent: RECENTLY_SELECTED_HISTORY_TYPES.AGENT_RECENTLY_SELECTED,
    NetRequest: RECENTLY_SELECTED_HISTORY_TYPES.NETWORK_REQUEST_RECENTLY_SELECTED,
};
